/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import ReactHtmlParser from 'react-html-parser';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { format } from 'date-fns';
import {
    object, string,
    bool,
} from 'prop-types';
import { compose } from 'redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { connect } from 'react-redux';
import InlineErrorMessage from '../../../../pages/Checkout/containers/CheckoutFloral/Partials/ErrorMessage/InlineErrorMessage';
import GraphqlCalendarContainer from '../../GraphqlProductPage/Partials/GraphqlPDPCalendar/GraphqlCalendarContainer';
import GraphqlPortalLoader from '../../GraphqlCommonComponents/GraphqlPortalLoader';
import { skuProductBuilder } from '../../../../pages/Checkout/containers/Common/Helpers/Sku-helper';
import { getFlexMessage } from '../../../../helpers/addons/getFlexMessage';
import { getFormatedDeliveryDate } from './calendarUtility';
import AddonProductUI from './AddonProductUI';
import PriceBreakDownUi from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceBreakDownUi';
import { getCaCampaign } from '../../../../../state/ducks/App/App-Selectors';
import CaPriceVariant from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/CaPriceTestType';

const styles = (theme) => ({
    orderItemContainer: {
        width: '100%',
        borderRadius: '5px',
    },
    itemDetails: {
        marginLeft: '10px',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '18px',
        '& span': {
            fontWeight: 'bold',
        },
    },
    imgProduct: {
        width: '100%',
        maxWidth: '140px',
    },
    itemProdName: {
        fontSize: '18px',
        padding: '0 10px',
        lineHeight: '26px',
    },
    btnDateDelivery: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        padding: '2px 0',
        margin: '0',
        textTransform: 'none',
        textDecoration: 'underline',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: '500',
        minWidth: '35px',
        '& span': {
            fontWeight: '500',
        },
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.white,
            textDecoration: 'underline',
        },
    },
    inlineErrorMessage: {
        paddingLeft: '10px',
    },
    flexMessage: {
        fontSize: '16px',
        lineHeight: '21px',
        display: 'flex',
        letterSpacing: '0.16px',
        color: '#000',
        marginTop: '4px',
    },
});

const isIternationalProduct = (itemDetails) => ['USA', 'US', 'CAN', 'CA'].includes(itemDetails?.deliveryInfo?.countryCode || '');

const deliveryTo = (itemDetails) => {
    let deliveryToText = <div>to: <strong>{itemDetails?.deliveryInfo?.zipCode || 'NA'}</strong></div>;
    const isInternationalProduct = isIternationalProduct(itemDetails);

    if (isInternationalProduct) {
        deliveryToText = <div>to: <strong>{itemDetails?.deliveryInfo?.zipCode || 'NA'} - International</strong></div>;
    }

    return deliveryToText;
};

const imageSrcBuilder = (imagePath, imageName, typeImg = '') => {
    let imageURL = `https:${imagePath}${imageName}`;

    if (typeImg !== '') {
        imageURL = imageURL.replace('t.jpg', `${typeImg}.jpg`);
    }

    return imageURL;
};

let newCalendarCartOrderDeliveryDate;
class CurrentProduct extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            calendarIsLoading: false,
            isOpenDeliveryDate: false,
            itemOrderId: null,
            skuCode: null,
            productDeliveryType: null,
            brandId: null,
            zipCode: null,
        };

        this.openModalDeliverydate = this.openModalDeliverydate.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    handleDeliveryAvailability = (boolean) => {
        this.setState({ deliveryAvailable: boolean, calendarIsLoading: false });
        this.closeModal();
    };

    setCalendarDataLoadingFlag = (boolean) => {
        this.setState({ calendarIsLoading: boolean });
    };

    openModalDeliverydate(itemOrderId, skuCode, productDeliveryType, brandId, zipCode) {
        this.setState({
            calendarIsLoading: true,
            isOpenDeliveryDate: true,
            itemOrderId,
            skuCode,
            productDeliveryType,
            brandId,
            zipCode,
        });
    }

    closeModal() {
        this.setState({
            isOpenDeliveryDate: false,
            itemOrderId: null,
            skuCode: null,
            productDeliveryType: null,
        });
    }

    isNewDeliveryCalendarEnabled = () => {
        const { featureFlags, productDetails } = this.props;
        const isNewCalendarEnabled = featureFlags['is-new-delivery-calendar-enabled'];
        const isNewCalendarCheckoutEnabled = featureFlags['is-new-delivery-calendar-checkout-enabled'];
        return isNewCalendarEnabled || (productDetails?.product?.brandCode === '1012' && !isNewCalendarEnabled && isNewCalendarCheckoutEnabled);
    }

    renderCartOrderDeliveryDate = () => {
        const { productDetails } = this.props;
        const { deliveryInfo = {} } = productDetails;
        if (this.isNewDeliveryCalendarEnabled()) {
            const formatString = (str) => {
                if (str && str.length > 0) {
                    return str.charAt(0).toUpperCase() + str.slice(1);
                }
                return '';
            };
            if (deliveryInfo && deliveryInfo.deliveryDateType && deliveryInfo.deliveryDate) {
                if (deliveryInfo.deliveryDateType.toLowerCase() === 'between' && deliveryInfo.deliveryRangeStartDate) {
                    const startDate = format(new Date(deliveryInfo.deliveryRangeStartDate), 'MMM dd');
                    const endDate = format(new Date(deliveryInfo.deliveryDate), 'MMM dd, yyyy');
                    newCalendarCartOrderDeliveryDate = `${formatString(deliveryInfo.deliveryDateType)} ${startDate} - ${endDate}`;
                    return newCalendarCartOrderDeliveryDate;
                }
                newCalendarCartOrderDeliveryDate = `${format(new Date(deliveryInfo.deliveryDate), 'eeee, MMM dd, yyyy')}`;
                return newCalendarCartOrderDeliveryDate;
            }
        }
        return  deliveryInfo?.deliveryDate ? format(new Date(deliveryInfo.deliveryDate), 'eeee, MMM dd, yyyy') : '';
    }

    render() {
        const {
            classes,
            productDetails,
            keyItem,
            serverSideOrderItemError,
            flags,
            wrapupAddonRedesign,
            isMobile,
            caCampaign,
            featureFlags,
        } = this.props;
        const {
            isOpenDeliveryDate, calendarIsLoading, deliveryAvailable,
            skuCode, productDeliveryType, itemOrderId, brandId, zipCode,
        } = this.state;
        const isCaTransparencyPricing = featureFlags['is-ca-transparency-all-in-pricing-enabled'];

        const isCaDelivery = CaPriceVariant(caCampaign, isCaTransparencyPricing);
        const { product = {}, selectedFlexOption = {} } = productDetails;

        let cartOrderDeliveryDate = this.renderCartOrderDeliveryDate();
        const itemZipCode = isIternationalProduct(productDetails) ? '00000' : productDetails?.zipCode;

        if (selectedFlexOption.calendarDate && selectedFlexOption.optionCode) {
            cartOrderDeliveryDate = getFormatedDeliveryDate(selectedFlexOption.calendarDate);
        }

        let src = '';

        if (product.imagePath && product.parentProductName) {
            src = imageSrcBuilder(product.imagePath, product.imageName, 'z');
        }
        const pdpListPrice = productDetails.product?.listPrice;
        const pdpSalePrice = productDetails.product?.salePrice;
        const isSalePrice = Number(pdpSalePrice) < Number(pdpListPrice);
        let updatedPrices = {
            retail: [{
                __typename: 'Price',
                value: pdpListPrice,
            }],
        };
        if (isSalePrice) {
            updatedPrices = {
                retail: [{
                    __typename: 'Price',
                    value: pdpListPrice,
                }],
                sale: [{
                    __typename: 'Price',
                    value: pdpSalePrice,
                }],
            };
        }
        const flexMessage = getFlexMessage(selectedFlexOption);

        const generateTotal = (newCharges, itemPrice, forceCharge = true) => {
            const charges = newCharges;
            const chargesOnly = [];
            (charges || []).forEach((data) => {
                if (!Number.isNaN(data.amount)) {
                    chargesOnly.push(parseFloat(data.amount));
                }
            });
            const total = chargesOnly.reduce((sum, num) => sum + num, 0) + parseFloat(itemPrice);
            return total;
        };

        return (
            <Grid container key={`CurrentProductAddons${keyItem}`}>
                {calendarIsLoading && !deliveryAvailable ? <GraphqlPortalLoader /> : null}
                {wrapupAddonRedesign ? (
                    <>
                        <AddonProductUI
                            itemZipCode={itemZipCode}
                            productDetails={productDetails}
                            product={product}
                            imgSrc={src}
                            serverSideOrderItemError={serverSideOrderItemError}
                            cartOrderDeliveryDate={cartOrderDeliveryDate}
                            flexMessage={flexMessage}
                            openModalDeliverydate={this.openModalDeliverydate}
                        />
                    </>
                ) :  (
                    <Grid container id="orderItem" className={classes.orderItemContainer}>
                        <Grid item xs={12} container spacing={0} className={classes.contOrderProduct}>
                            <Grid item id="itemImage" xs={2} sm={2} lg={2}>
                                <img
                                    className={classes.imgProduct}
                                    src={`${src}?quality=100`}
                                    alt="product"
                                />
                            </Grid>
                            <Grid
                                item
                                id="product-added"
                                data-test="product-details"
                                name="productDetails"
                                xs={10}
                                sm={10}
                                lg={10}
                            >
                                <div className={classes.itemProdName}><strong>{ReactHtmlParser(product?.parentProductName)}</strong></div>
                                <div className={classes.itemDetails}>{skuProductBuilder(product?.productCode)}</div>

                                <div className={classes.inlineErrorMessage}> <InlineErrorMessage error={serverSideOrderItemError} /> </div>
                                <div className={classes.itemDetails}>
                                    Qty: <strong>{productDetails.itemInfo?.quantity}</strong>
                                </div>
                                <div className={classes.itemDetails}>
                                    Price: {!isCaDelivery &&  <strong>{`$${parseFloat(generateTotal(productDetails?.itemInfo?.charges, productDetails?.itemInfo?.price)).toFixed(2)}`}</strong>}
                                    <PriceBreakDownUi
                                        dynamicPriceData={{
                                            ...productDetails?.itemInfo || {},
                                            prices: [
                                                {
                                                    display: generateTotal(productDetails?.itemInfo?.charges, pdpListPrice).toFixed(2),
                                                    displayCharges: productDetails?.itemInfo?.displayCharges,
                                                    value: parseFloat(pdpListPrice).toFixed(2),
                                                    type: 'retail',
                                                    charges: productDetails?.itemInfo?.charges || [],
                                                    total: generateTotal(productDetails?.itemInfo?.charges, pdpListPrice).toFixed(2),
                                                },
                                                {
                                                    charges: productDetails?.itemInfo?.charges || [],
                                                    display: generateTotal(productDetails?.itemInfo?.charges, productDetails?.itemInfo?.price).toFixed(2),
                                                    displayCharges: productDetails?.itemInfo?.displayCharges,
                                                    total: generateTotal(productDetails?.itemInfo?.charges, productDetails?.itemInfo?.price).toFixed(2),
                                                    value: parseFloat(productDetails?.itemInfo?.price).toFixed(2),
                                                    type: 'sale',
                                                },
                                            ],
                                            brand: productDetails?.product?.brandCode,
                                            productType: productDetails?.product?.productType,
                                        }}
                                        skuPriceRange={updatedPrices}
                                        isCaDelivery={isCaDelivery}
                                    />
                                </div>
                                <div className={classes.itemDetails}>
                                    {'Date selected: '}
                                    <Button
                                        className={classes.btnDateDelivery}
                                        aria-label={cartOrderDeliveryDate}
                                        onClick={() => this.openModalDeliverydate(productDetails.cartItemId, product?.productCode, product?.productType, product?.brandCode, itemZipCode)}
                                    >
                                        {cartOrderDeliveryDate || 'Select a delivery date'}
                                    </Button>
                                    {flexMessage && <div className={classes.flexMessage}>{flexMessage}</div>}
                                    <div>
                                        {deliveryTo(productDetails)}
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {
                    skuCode && productDeliveryType
                    && (
                        <GraphqlCalendarContainer
                            close={this.closeModal}
                            isOpen={isOpenDeliveryDate}
                            selectedItemId={skuCode}
                            productDeliveryType={productDeliveryType}
                            setCalendarDataLoadingFlag={
                                this.setCalendarDataLoadingFlag
                            }
                            handleDeliveryAvailability={
                                this.handleDeliveryAvailability
                            }
                            orderItemId={itemOrderId}
                            brandId={brandId}
                            pageType="shipping"
                            sympathyValue=""
                            partNumber=""
                            ageDetails={{}}
                            zipCode={zipCode}
                        />
                    )
                }
            </Grid>
        );
    }
}

CurrentProduct.propTypes = {
    classes: object.isRequired,
    productDetails: object,
    keyItem: string,
    serverSideOrderItemError: string,
    flags: object,
    featureFlags: object,
    wrapupAddonRedesign: bool,
    isMobile: bool,
    caCampaign: object,
};

CurrentProduct.defaultProps = {
    serverSideOrderItemError: '',
    productDetails: {
        product: {},
    },
    keyItem: '',
    flags: {},
    featureFlags: {},
    wrapupAddonRedesign: false,
    isMobile: false,
    caCampaign: {},
};

const mapStateToProps = (state) => ({
    caCampaign: getCaCampaign(state),
});

const enhance = compose(
    withLDConsumer(),
    withStyles(styles),
    withRouter,
    connect(mapStateToProps),
);

export default enhance(CurrentProduct);
